import apiWorker from '../apiWorker'

const payment_event_logs = {

    create: (data) => apiWorker('post', `/api/v1/billing/payment_event_logs/create`, data),

}

export default payment_event_logs;